<template>
<div>
    <div class="flex ai-c jc-fe">
        <button class="mr-3" type="button" :disabled="is_loading_letter_batches" @click="loadLetterBatches">
            <i class="material-icons">refresh</i>
        </button>
    </div>

    <card class="mt-3">
        <template slot="body">
            <div class="mb-3">
                <form class="flex ai-c" @submit.prevent="loadLetterBatches">
                    <div>
                        <label for="filter-facility-number">Facility Number</label>
                        <input id="filter-facility-number" type="text" v-model="filters.facility_number" />
                    </div>

                    <div class="ml-5" style="width: 200px;">
                        <label>Letter Type</label>
                        <select-input
                            :active-index="selected_letter_type_filter_index"
                            :choices="letter_type_filter_options"
                            @change="(index) => selected_letter_type_filter_index = index" />
                    </div>

                    <div class="flex-a ta-r">
                        <button class="danger small mr-3" type="reset" @click="resetFilters">Reset</button>
                        <button type="submit">Search</button>
                    </div>
                </form>
            </div>

            <vue-table ref="letter_batches_table"
                :class="['table-loads', { 'loading': is_loading_letter_batches }]"
                api-url="/api/letter-batches"
                :append-params="api_params"
                :per-page="50"
                table-height="475px"
                data-path="data.data"
                pagination-path="data.pagination"
                :http-options="http_options"
                :fields="columns"
                no-data-template="<span>No letter batches to show.</span>"
                @vuetable:loading="is_loading_letter_batches = true"
                @vuetable:loaded="is_loading_letter_batches = false"
                @vuetable:load-error="onTableLoadError">
                <template slot="download" slot-scope="props">
                    <a class="button small" :href="`${api_base_path}/${props.rowData.filename}`" target="_blank">Download</a>
                </template>

                <template slot="save_time" slot-scope="props">
                    <span v-if="props.rowData.save_time === null" class="gray-message">---</span>
                    <span v-else :title="props.rowData.save_time">
                        {{ dayjs(props.rowData.save_time).format("M/DD/YYYY") }}
                    </span>
                </template>

                <template slot="mail_time" slot-scope="props">
                    <span v-if="props.rowData.mail_time === null" class="gray-message">---</span>
                    <span v-else :title="props.rowData.mail_time">
                        {{ dayjs(props.rowData.mail_time).format("M/DD/YYYY") }}
                    </span>
                </template>
            </vue-table>
        </template>
    </card>
</div>
</template>

<script>
import Vue from "vue"
import dayjs from "dayjs"
import http from "@/http"
import store from "@/store"
import { letterBatchesColumns } from "@/utilities/columns"

export default {
    data () {
        return {
            columns: letterBatchesColumns,
            dayjs,
            filters: {
                facility_number: null,
                letter_type: null
            },
            letter_type_filter_options: [
                { key: "initial", label: "Audit", badge: null },
                { key: "reminder", label: "Reminder", badge: null },
                { key: "welcome", label: "Welcome", badge: null }
            ],
            http_options: {
                baseURL: this.$http.defaults.baseURL,
                headers: { "X-Authorization": store.state.token.token },
                transformResponse: [(raw) => {
                    try {
                        return JSON.parse(raw)
                    } catch (error) {
                        return raw
                    }
                }]
            },
            is_loading_letter_batches: false,
            selected_letter_type_filter_index: -1
        }
    },

    computed: {
        api_base_path () {
            return `${http.defaults.baseURL}/api/facilities/download-letters`
        },

        api_params () {
            const params = {}

            for (const key in this.filters) {
                if (this.filters[key] !== null && this.filters[key].length > 0) {
                    params[key] = this.filters[key].trim()
                }
            }

            return params
        }
    },

    watch: {
        selected_letter_type_filter_index (newValue) {
            const newOption = this.letter_type_filter_options[newValue]

            if (newOption === null) {
                this.filters.letter_type = null
            } else {
                this.filters.letter_type = newOption.key
            }

            this.loadLetterBatches()
        }
    },

    methods: {
        /**
         * Tell the table to load load more data.
         */
        loadLetterBatches () {
            Vue.nextTick(() => {
                this.$refs.letter_batches_table.reload()
            })
        },

        /**
         * Display an error message modal when the table cannot load data.
         */
        onTableLoadError ({ response: { data: { data } } }) {
            this.$modalManager.add({ state: "bad", header: "Error", body: data })
        },

        /**
         * Reset all the table filters.
         */
        resetFilters () {
            for (const key in this.filters) {
                this.filters[key] = null
            }

            this.selected_letter_type_filter_index = -1

            this.loadLetterBatches()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/monitor/LetterBatchesPage.vue